import React, { Component } from 'react';
import ReactHoverFlip from 'react-hover-flip'
import { Container, Col, Row } from 'react-bootstrap';

import logo from '../../assets/img/Logo-Galeb-1.png';
import Spinner from '../common/Spinner';
export class UserCard extends Component {


  render() {
    let backItems;
    console.log(this.props.description);
    if(this.props.description === undefined)
    {
      backItems  = (
        <div className="card card-user" >
        <h3>{this.props.name}</h3><hr />
        <div className="content" style={{backgroundColor:'grey', border: '1px solid #F5E8C7', margin: 'auto'}}>
        <div className="logo-img">
              <img src={logo} alt="logo_image" style={{width: '200px'}}/>
            </div>
      </div>
    </div>
      );
    }
    else {
      backItems = (
        <div className="card card-user" >
        <h3>{this.props.name}</h3><hr />
      <div className="content" style={{backgroundColor:'#F7ECDE', border: '1px solid #F5E8C7', margin: 'auto'}}>
          <p className="description text-center">{this.props.description}</p>
      </div>
    </div>
      )
    }
    
    return (
      <ReactHoverFlip
        front={
          <div className="card card-user" >
            
            <div className="image" style={{background: 'linear-gradient(90deg, hsla(218, 25%, 28%, 1) 0%, hsla(210, 32%, 71%, 1) 100%)'}}>
              
            </div>
            <div className="content" >
              <div className="author text-center" style={{ margin: 'auto' }}>
                <h3 className="title">
                  <br />
                  {this.props.name}
                  <br />
                  <small>{this.props.socials}</small> <br></br>
                  <ul class="list-inline">
                    <li class="list-inline-item">{this.props.timeFrom}</li>
                    -
                    <li class="list-inline-item">{this.props.timeTo}</li>
                  </ul>
                </h3>
              </div>{this.props.userName}
            </div>
            <hr />
          </div>}
        back={backItems}
        direction="horizontal"
        height={400}
      />
    );
  }
}

export default UserCard;
